import { Component, OnInit } from '@angular/core';
import { EventEmitterService } from 'services/event-emitter.service';
import { ProspectService } from 'services/prospect.service';
import { Router } from '@angular/router';
import { ProspectTourSummary } from 'app/models/prospect-tour-summary';
import { createCalendar } from 'add-to-calendar-buttons';
import { ErrorService } from 'services/error.service';
import { SplashService } from 'services/splash.service';

@Component({
  selector: 'app-summary-selftour',
  templateUrl: './summary-selftour.component.html',
  styleUrls: ['./summary-selftour.component.css']
})
export class SummarySelftourComponent implements OnInit {

  model: ProspectTourSummary = new ProspectTourSummary();
  selfTourKey: String = null;
  errorMessage: String = null;
  tourDateSummary: String = null;

  constructor(private eventEmitterService: EventEmitterService, private prospectService: ProspectService, public router: Router, private errorService: ErrorService, private splashService: SplashService) {
    this.eventEmitterService.selfTourStepChange(5);

    let selfTourKey = localStorage.getItem('SelfTourKey');
    let summaryError = localStorage.getItem('SummaryError');

    if (summaryError !== null && summaryError !== undefined)
    {
      localStorage.clear();
      this.errorMessage = summaryError;
    }
    else {
      if (selfTourKey !== null && selfTourKey !== undefined)
      {
        this.selfTourKey = selfTourKey;
      }
      else {
        this.router.navigate(['/tour/selftour/schedule-selftour']);
      }
  
      this.prospectService.GetProspectSelfTourSummary(this.selfTourKey).subscribe(res => this.onGetProspectSelfTourSummary(res), err => this.errorService.showError(err))
    }  
   }

  ngOnInit() {
    this.splashService.updateSplash("selftour");
  }

  onGetProspectSelfTourSummary(tour: ProspectTourSummary)
  {
    this.model = tour;
    this.createCalendarWidget();
  }

  createCalendarWidget(){

    var myCalendar = createCalendar({
      data: {
        title: `Self Tour at ${this.model.Address}`,
        start: new Date(this.model.EventStart),
        end: new Date(this.model.EventEnd),     
        address: this.model.Address,
        description: ''
      }
    });
    
    myCalendar.querySelector('label.add-to-calendar-checkbox').innerHTML = "<span class='ui-button-icon-left ui-clickable fa fa-fw fa-calendar'></span>&nbsp;<span id='oh-summary-atc-text'>ADD TO CALENDAR</span>";

    document.querySelector('#selftour-cal-anchor').appendChild(myCalendar);
  }

  finish(){
    this.router.navigate(['/account/tours']);
  }

  back()
  {
    this.router.navigate(['/tour/selftour/schedule-selftour']);
  }

}
